export const dnldSMSCRates = (builder) => ({
    dnldSMSCRates: builder.mutation({
      query: ({ search, login_user_type, created_by_userid, loggedin_user_id, user_type_id, }) => {
        return {
          url: '/download_smsc_rate_data',
          method: 'GET',
          params: { search, login_user_type, created_by_userid, loggedin_user_id, user_type_id, },
          headers: {
            'Content-Type': 'text/csv',
          },
          responseHandler: (response)=>response.blob(),
        };
      },
    }),
  });
  